import { render, staticRenderFns } from "./DalSettings.vue?vue&type=template&id=6ae65346&"
import script from "./DalSettings.vue?vue&type=script&lang=js&"
export * from "./DalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports